import {
  getListOfJobFamilies,
  getListOfJobFamilyLevels,
} from "@/api/jobFamilyAPI";

/** Map a job-family list API row → JobFamilyPickerWithAdd / JobFamilyPickerDialog shape. */
export function mapApiJobFamilyToPickerResult(family) {
  return {
    jobFamilyId: family.id,
    jobFamilyName: family.name,
    // API code may include "#"; pickers render `#{{ code }}` themselves.
    code: String(family.code || "").replace(/^#/, ""),
    levels: Array.isArray(family.levels) ? family.levels : [],
  };
}

/**
 * Type-to-search (or browse with empty query) for job-family pickers.
 * Fetches draft + active families, then loads each family's levels — list rows do
 * not embed levels (same contract as PositionPageHeader ER-11838).
 */
export async function loadJobFamilyPickerResults(accountId, query = "") {
  const trimmed = (query || "").trim();
  if (!accountId) return [];

  const { data } = await getListOfJobFamilies(
    accountId,
    { search: trimmed, status: ["draft", "active"] },
    { page: 1, pageSize: 100 }
  );
  const families = Array.isArray(data?.results) ? data.results : [];

  return Promise.all(
    families.map(async (family) => {
      let levels = [];
      try {
        const levelRes = await getListOfJobFamilyLevels(accountId, family.id);
        levels = Array.isArray(levelRes?.data) ? levelRes.data : [];
      } catch {
        levels = [];
      }
      return mapApiJobFamilyToPickerResult({ ...family, levels });
    })
  );
}
